// Onboarding step configurations

export interface OnboardingStep {
    id: string;
    title: string;
    route: string;
}

// Extended onboarding steps for architect/subcontractor (7 steps)
export const EXTENDED_STEPS: OnboardingStep[] = [
    { id: 'business-info', title: 'Business Info', route: 'business-info' },
    { id: 'classification', title: 'Classification', route: 'classification' },
    { id: 'contact-info', title: 'Contact Info', route: 'contact-info' },
    { id: 'documents', title: 'Documents', route: 'documents' },
    { id: 'agreements', title: 'Agreements', route: 'agreements' },
    { id: 'add-users', title: 'Add Users', route: 'add-users' },
    { id: 'review', title: 'Review & Finish', route: 'review' },
];// Company onboarding steps (5 steps) — routes must match the actual router paths in src/routes/index.tsx
export const COMPANY_STEPS: OnboardingStep[] = [
    { id: 'profile', title: 'Company Details', route: 'profile' },
    { id: 'teamMembers', title: 'Team Information', route: 'teamMembers' },
    { id: 'configuration', title: 'Configuration', route: 'configuration' },
    { id: 'elements', title: 'Your Elements', route: 'elements' },
    { id: 'complete', title: 'Review & Finish', route: 'complete' },
];

// Helper function to get steps based on account type
export const getStepsForAccountType = (accountType: string): OnboardingStep[] => {
    return accountType === 'company' ? COMPANY_STEPS : EXTENDED_STEPS;
};
